<main>
  <div class="content-container blank-layout home-dashboard">
    <!-- KPI Cards -->
    <div
      class="mt-4 grid gap-4 dashboard-kpis-container"
      style="grid-template-columns: repeat(auto-fit, minmax(260px, 1fr))"
    >
      <app-stats-card
        [heading]="'profitAndLoss' | translate"
        iconSrc="assets/icons/kpi/profit-loss.svg"
        [amount]="currencyUid + ' ' + (kpiProfitLoss | number: '1.2-2')"
        [loading]="kpiProfitLoss === undefined"
        tooltipContent="last30Days"
      ></app-stats-card>

      <app-stats-card
        [heading]="'totalGrossProfit' | translate"
        iconSrc="assets/icons/kpi/gross-profit.svg"
        [amount]="
          currencyUid + ' ' + (kpiGrossProfit[1]?.value | number: '1.2-2')
        "
        [trendData]="{
          label: kpiGrossProfit[1]?.percentageChange,
          increasing: kpiGrossProfit[1]?.increasing
        }"
        [loading]="kpiGrossProfit[1]?.value === null"
        tooltipContent="last30Days"
      ></app-stats-card>

      <app-stats-card
        [heading]="'totalSales' | translate"
        iconSrc="assets/icons/kpi/sales.svg"
        [amount]="
          currencyUid + ' ' + (kpiGrossProfit[0]?.value | number: '1.2-2')
        "
        [trendData]="{
          label: kpiGrossProfit[0]?.percentageChange,
          increasing: kpiGrossProfit[0]?.increasing
        }"
        [loading]="kpiGrossProfit[0]?.value === null"
        tooltipContent="last30Days"
      ></app-stats-card>

      <app-stats-card
        [heading]="'grossProfitMargin' | translate"
        iconSrc="assets/icons/kpi/cash.svg"
        headingColor="#717171"
        [amount]="(kpiGrossProfit[2]?.value * 100 | number: '1.2-2') + '%'"
        [trendData]="{
          label: kpiGrossProfit[2]?.percentageChange,
          increasing: kpiGrossProfit[2]?.increasing
        }"
        [loading]="kpiGrossProfit[2]?.value === null"
        tooltipContent="last30Days"
      ></app-stats-card>
    </div>

    <!-- Charts Row -->
    <div
      class="flex flex-row flex-1 gap-4 dashboard-charts-container mt-4 w-100"
    >
      <kendo-card [appLoading]="pieChart.length < 1">
        <kendo-card-header class="px-2 pb-3">
          <div class="flex justify-between">
            <div class="flex-col">
              <h2 kendoCardTitle>
                <b>{{ "customerRanking" | translate }}</b>
              </h2>
              <p class="m-0">
                {{ "rankedByTotalSalesAndTotalProfits" | translate }}
              </p>
            </div>
            <app-tooltip
              [content]="'last90Days' | translate"
              class="tooltip"
            ></app-tooltip>
          </div>
        </kendo-card-header>
        <kendo-chart>
          <kendo-chart-tooltip>
            <ng-template
              kendoChartSeriesTooltipTemplate
              let-value="value"
              let-category="category"
              let-series="series"
            >
              {{ category }} ({{ series.name }}):
              {{ pieChartTooltipValue(value) }}%
            </ng-template>
          </kendo-chart-tooltip>
          <kendo-chart-series>
            @for (series of pieChart; track series; let outermost = $last) {
              <kendo-chart-series-item
                type="donut"
                [name]="series.name"
                [data]="series.data"
                [autoFit]="true"
                categoryField="customerName"
                field="percentage"
                [padding]="4"
                [border]="{ width: 6, color: '#ffffff' }"
              >
              </kendo-chart-series-item>
            }
          </kendo-chart-series>
          <kendo-chart-legend [visible]="false"></kendo-chart-legend>
        </kendo-chart>
      </kendo-card>
      <!-- FUNNEL -->
      <kendo-card [appLoading]="!salesFunnel">
        <kendo-card-header class="px-2 pb-3">
          <h2 kendoCardTitle>
            <b>{{ "salesFunnel" | translate }}</b>
          </h2>
          <p class="m-0">
            {{ "quotationsConfirmedOrdersAndDeliveredOrders" | translate }}
          </p>
        </kendo-card-header>
        <kendo-card-body>
          <kendo-chart [seriesColors]="seriesColors">
            <kendo-chart-title></kendo-chart-title>
            <kendo-chart-series>
              <kendo-chart-series-item
                type="funnel"
                [data]="salesFunnel"
                field="value"
                categoryField="name"
                [dynamicSlope]="false"
                [dynamicHeight]="true"
                [margin]="4"
              >
                <kendo-chart-series-item-labels
                  background="none"
                  color="white"
                  format="N0"
                >
                </kendo-chart-series-item-labels>
              </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-tooltip>
              <ng-template
                kendoChartSeriesTooltipTemplate
                let-category="category"
              >
                {{ category }}
              </ng-template>
            </kendo-chart-tooltip>
            <kendo-chart-legend [visible]="false"></kendo-chart-legend>
          </kendo-chart>
        </kendo-card-body>
      </kendo-card>
      <!-- Sales Report -->
      <kendo-card [appLoading]="!activeSalesReport">
        <kendo-card-header class="px-2 pb-3">
          <div class="flex justify-between items-start">
            <div>
              <h2 kendoCardTitle>
                <b>{{ "salesReport" | translate }}</b>
              </h2>
              <p class="m-0">
                {{
                  (salesReportMode === "rolling"
                    ? "trailingSixMonthsOfSalesAndGrossProfitMargin"
                    : "lastSixCalendarMonthsSalesAndGrossProfit"
                  ) | translate
                }}
              </p>
            </div>
            <kendo-buttongroup
              class="status-group status-group--primary sales-report-mode-toggle"
            >
              <button
                type="button"
                kendoButton
                class="status-button"
                [ngClass]="{
                  'status-button--active': salesReportMode === 'rolling',
                  'status-button--inactive': salesReportMode !== 'rolling'
                }"
                (click)="toggleSalesReportMode('rolling')"
              >
                {{ "rolling" | translate }}
              </button>
              <button
                type="button"
                kendoButton
                class="status-button"
                [ngClass]="{
                  'status-button--active': salesReportMode === 'monthly',
                  'status-button--inactive': salesReportMode !== 'monthly'
                }"
                (click)="toggleSalesReportMode('monthly')"
              >
                {{ "monthly" | translate }}
              </button>
            </kendo-buttongroup>
          </div>
        </kendo-card-header>
        <kendo-chart [seriesColors]="seriesColors" class="kendo-chart-wrapper">
          <kendo-chart-axis-defaults>
            <kendo-chart-axis-defaults-labels format="n0">
            </kendo-chart-axis-defaults-labels>
          </kendo-chart-axis-defaults>
          <kendo-chart-title></kendo-chart-title>
          <kendo-chart-legend
            position="top"
            orientation="horizontal"
            [spacing]="12"
            [item]="{
              highlight: { visible: false },
              visual: salesReportLegendMarkerVisual
            }"
          >
          </kendo-chart-legend>
          <kendo-chart-series>
            @for (item of activeSalesReport; track item) {
              <kendo-chart-series-item
                [data]="item.items"
                [name]="item.value"
                field="value"
                categoryField="interval"
                type="column"
                [gap]="1.5"
                [spacing]="0.4"
              >
              </kendo-chart-series-item>
            }
          </kendo-chart-series>
        </kendo-chart>
      </kendo-card>
    </div>
    <!--End Charts Row -->

    <!-- Grids Row -->
    <div
      class="flex flex-row flex-1 gap-4 dashboard-tables-container mt-4 w-100"
    >
      <!-- Sales Rank -->
      <kendo-card
        [appLoading]="!customerRanking?.totalSalesRank"
        class="dashboard-card dashboard-card--table"
      >
        <kendo-card-header class="dashboard-card__header">
          <div class="dashboard-card__title">
            {{ "topCustomersByRevenue" | translate }}
          </div>
          <button
            type="button"
            class="dashboard-card__menu"
            aria-label="More actions"
          >
            <app-tooltip
              [content]="'last90Days' | translate"
              class="tooltip"
            ></app-tooltip>
          </button>
        </kendo-card-header>
        <kendo-grid
          class="dashboard-grid"
          [data]="customerRanking?.totalSalesRank"
        >
          <kendo-grid-column
            title="{{ 'rank' | translate }}"
            [width]="80"
            headerClass="text-center"
            class="text-center"
          >
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
              <div
                class="rank-badge"
                [ngClass]="'rank-badge--' + (rowIndex + 1)"
              >
                {{ rowIndex + 1 }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [field]="'customerName'"
            title="{{ 'name' | translate }}"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-hyperlink
                [title]="dataItem?.customerName"
                path="/customers/view"
                [params]="{ id: dataItem?.customerUid }"
              ></app-hyperlink>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="amount"
            title="{{ 'amount' | translate }}"
            class="text-end"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-currency-total
                [currencyUid]="currencyUid"
                [totalAmount]="dataItem?.amount"
              ></app-currency-total>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </kendo-card>
      <!-- Profit Rank -->
      <kendo-card
        [appLoading]="!customerRanking?.grossProfitRank"
        class="dashboard-card dashboard-card--table"
      >
        <kendo-card-header class="dashboard-card__header">
          <div class="dashboard-card__title">
            {{ "topCustomersByGrossProfit" | translate }}
          </div>
          <button
            type="button"
            class="dashboard-card__menu"
            aria-label="More actions"
          >
            <app-tooltip
              [content]="'last90Days' | translate"
              class="tooltip"
            ></app-tooltip>
          </button>
        </kendo-card-header>
        <kendo-grid
          class="dashboard-grid"
          [data]="customerRanking?.grossProfitRank"
        >
          <kendo-grid-column
            title="{{ 'rank' | translate }}"
            [width]="80"
            headerClass="text-center"
            class="text-center k-border-none"
          >
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
              <div
                class="rank-badge"
                [ngClass]="'rank-badge--' + (rowIndex + 1)"
              >
                {{ rowIndex + 1 }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [field]="'customerName'"
            title="{{ 'name' | translate }}"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-hyperlink
                [title]="dataItem?.customerName"
                path="/customers/view"
                [params]="{ id: dataItem?.customerUid }"
              ></app-hyperlink>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="amount"
            title="{{ 'amount' | translate }}"
            class="text-end"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-currency-total
                [currencyUid]="currencyUid"
                [totalAmount]="dataItem?.amount"
              ></app-currency-total>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </kendo-card>
    </div>
    <!-- End Grids Row -->

    <!-- Grids Row -->
    <div
      class="flex flex-row flex-1 gap-4 dashboard-tables-container mt-4 w-100"
    >
      <!-- Sales Rank -->
      <kendo-card
        [appLoading]="!productRanking?.totalSalesRank"
        class="dashboard-card dashboard-card--table"
      >
        <kendo-card-header class="dashboard-card__header">
          <div class="dashboard-card__title">
            {{ "topProductsByRevenue" | translate }}
          </div>
          <button
            type="button"
            class="dashboard-card__menu"
            aria-label="More actions"
          >
            <app-tooltip
              [content]="'last90Days' | translate"
              class="tooltip"
            ></app-tooltip>
          </button>
        </kendo-card-header>
        <kendo-grid
          class="dashboard-grid"
          [data]="productRanking?.totalSalesRank"
        >
          <kendo-grid-column
            title="{{ 'rank' | translate }}"
            [width]="80"
            headerClass="text-center"
            class="text-center"
          >
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
              <div
                class="rank-badge"
                [ngClass]="'rank-badge--' + (rowIndex + 1)"
              >
                {{ rowIndex + 1 }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [field]="'productName'"
            title="{{ 'name' | translate }}"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-hyperlink
                [title]="dataItem?.productName"
                path="/products/view"
                [params]="{ id: dataItem?.productUid }"
              ></app-hyperlink>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="amount"
            title="{{ 'amount' | translate }}"
            class="text-end"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-currency-total
                [currencyUid]="currencyUid"
                [totalAmount]="dataItem?.amount"
              ></app-currency-total>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </kendo-card>
      <!-- Profit Rank -->
      <kendo-card
        [appLoading]="!productRanking?.grossProfitRank"
        class="dashboard-card dashboard-card--table"
      >
        <kendo-card-header class="dashboard-card__header">
          <div class="dashboard-card__title">
            {{ "topProductsByGrossProfit" | translate }}
          </div>
          <button
            type="button"
            class="dashboard-card__menu"
            aria-label="More actions"
          >
            <app-tooltip
              [content]="'last90Days' | translate"
              class="tooltip"
            ></app-tooltip>
          </button>
        </kendo-card-header>
        <kendo-grid
          class="dashboard-grid"
          [data]="productRanking?.grossProfitRank"
        >
          <kendo-grid-column
            title="{{ 'rank' | translate }}"
            [width]="80"
            headerClass="text-center"
            class="text-center"
          >
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
              <div
                class="rank-badge"
                [ngClass]="'rank-badge--' + (rowIndex + 1)"
              >
                {{ rowIndex + 1 }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [field]="'productName'"
            title="{{ 'name' | translate }}"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-hyperlink
                [title]="dataItem?.productName"
                path="/products/view"
                [params]="{ id: dataItem?.productUid }"
              ></app-hyperlink>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="amount"
            title="{{ 'amount' | translate }}"
            class="text-end"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <app-currency-total
                [currencyUid]="currencyUid"
                [totalAmount]="dataItem?.amount"
              ></app-currency-total>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </kendo-card>
    </div>
    <!-- End Grids Row -->
  </div>
</main>
